/**
 * Iter 85.1 / Phase E6 Sprint 1 — Privacy Boundary Banner (D41-G).
 *
 * Mandatory on every workforce surface per operator requirement. Renders
 * "What We Collect" and "What We Do Not Collect" sections explicitly.
 */
import { ShieldCheck, ShieldWarning } from "@phosphor-icons/react";

export default function WorkforcePrivacyBanner() {
    return (
        <div className="border-2 border-blue-200 bg-blue-50/40 rounded p-3 text-xs"
            data-testid="workforce-privacy-banner">
            <div className="flex items-center gap-2 font-semibold text-blue-800 mb-2">
                <ShieldCheck size={14} /> Workforce Privacy Boundary
            </div>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-3">
                <div data-testid="workforce-privacy-collect">
                    <div className="text-emerald-700 font-medium mb-1 flex items-center gap-1">
                        <ShieldCheck size={12} /> What We Collect
                    </div>
                    <ul className="list-disc pl-4 text-slate-700 space-y-0.5 text-[11px]">
                        <li>Active / Idle status (boolean signal only)</li>
                        <li>Session duration (login / logout times)</li>
                        <li>Break and check-in / check-out events you record</li>
                        <li>Tab-visible state (foreground vs background)</li>
                        <li>Heartbeat version + client timestamp (for diagnostics)</li>
                    </ul>
                </div>
                <div data-testid="workforce-privacy-do-not-collect">
                    <div className="text-rose-700 font-medium mb-1 flex items-center gap-1">
                        <ShieldWarning size={12} /> What We Do NOT Collect
                    </div>
                    <ul className="list-disc pl-4 text-slate-700 space-y-0.5 text-[11px]">
                        <li>Passwords or password hashes</li>
                        <li>Keystroke content (what you type — words, sequences)</li>
                        <li>Screen captures, thumbnails, or webcam frames</li>
                        <li>Microphone audio of any kind</li>
                        <li>URLs visited, page titles, browser history, tab titles</li>
                        <li>Clipboard content, file paths, mouse coordinates</li>
                        <li>Device or browser fingerprints; no IP scoring</li>
                    </ul>
                </div>
            </div>
        </div>
    );
}
